// Higher value = closer to the corner. Current order (highest first):
// pwa-update-prompt > announcement > active-call > browser-session > windows-desktop >
// floating-list-navigation-panel.
export const CornerSlotPriority = {
  'active-call': 50,
  announcement: 100,
  'browser-session': 45,
  'floating-list-navigation-panel': 40,
  'pwa-update-prompt': 1000,
  'windows-desktop': 44,
} as const

export type CornerSlotFeature = keyof typeof CornerSlotPriority
